import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PatrimonyDistribution } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PatrimonyDistribution & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        riskProfil: this.formBuilder.group({
          gender: [
            entity?.riskProfil?.patrimonyDistribution || null,
            Validators.required,
          ],
        }),
        // patrimonyDistribution: [
        //   entity?.patrimonyDistribution || null,
        //   Validators.required,
        // ],
      },
      options,
    );
  }
  generate(entity: PatrimonyDistribution[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
